import NavigationEngine from 'rlink-router/NavigationEngine';

export default class NoopNavigationEngine extends NavigationEngine {
  onReturnToState(eventListener) {
    // ... noop
  }
}




// WEBPACK FOOTER //
// ./lib/rlink-router/NoopNavigationEngine.js